import React from "react";
import { Button, Spinner } from "react-bootstrap";

interface AddCacheItemControlsProps {
  upload: boolean;
  isLoading: boolean;
  uploadError: boolean;
  addError: boolean;
  handleCancel: () => void;
  handleSubmit: () => void;
  handleUploadSubmit: () => void;
}

const AddCacheItemControls: React.FC<AddCacheItemControlsProps> = ({
  upload,
  isLoading,
  uploadError,
  addError,
  handleCancel,
  handleSubmit,
  handleUploadSubmit,
}) => {
  return (
    <>
      <Button
        className="btn btn-secondary btn-sm"
        size="sm"
        variant="secondary"
        onClick={handleCancel}
      >
        Cancel
      </Button>
      {upload ? (
        <Button
          size="sm"
          className="btn btn-primary"
          disabled={uploadError}
          type="submit"
          onClick={handleUploadSubmit}
        >
          Process CSV file
          {isLoading && (
            <Spinner className="ms-2" size="sm" animation="border" />
          )}
        </Button>
      ) : (
        <Button
          size="sm"
          className="btn btn-primary"
          disabled={addError}
          type="submit"
          onClick={handleSubmit}
        >
          Add cache item
          {isLoading && (
            <Spinner className="ms-2" size="sm" animation="border" />
          )}
        </Button>
      )}
    </>
  );
};

export { AddCacheItemControls };
